import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { Tables } from '@/integrations/supabase/types';
import { captureSentryException } from '@/integrations/sentry/client';

export type TransactionDetail = Tables<'transactions'> & {
  accounts: Pick<Tables<'accounts'>, 'id' | 'name' | 'nickname' | 'balance' | 'currency' | 'type' | 'account_number'> | null;
  categories: Pick<Tables<'categories'>, 'name' | 'icon'> | null;
  sub_categories: Pick<Tables<'sub_categories'>, 'name' | 'icon'> | null;
};

export function useTransactionDetail(id: string) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['transaction-detail', id, user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('transactions')
        .select('*, accounts(*), categories(name, icon), sub_categories(name, icon)')
        .eq('id', id)
        .eq('user_id', user!.id)
        .single();

      if (error?.code === 'PGRST116') throw new Error('Transaction not found');
      if (error) {
        captureSentryException(error);
        throw error;
      }

      return data as unknown as TransactionDetail;
    },
    staleTime: 86_400_000,
    gcTime: 86_400_000,
    enabled: !!user && !!id,
  });
}
